import React, { useState } from 'react'
import "./style/Header.css"
import ListIcon from '@material-ui/icons/List';
import BackDrop from './BackDrop';
import Drawer from './Drawer';

function Header() {

    const[backDrop, setBackDrop]=useState('none');
    const[drawer, setDrawer]=useState(180.14);
    
    const OpenDrawer=()=> {
        setDrawer(0);
        setBackDrop('block');
    };

    const CloseDrawer=()=>{
        setDrawer(180.14);
        setBackDrop('none');
    }
    return (
        <div className="header">
            <Drawer drawer={drawer} fn={CloseDrawer}/>
            <BackDrop backDrop={backDrop} fn={CloseDrawer}/>
            <div className="header__logo">Desig<span>ner.</span></div>
            <div className="header__menu">
                <ul>
                    <li ><a href="#home">Home</a> </li>
                    <li ><a href="#about">About Us</a></li>
                    <li ><a href="#service">Service</a></li>
                    <li ><a href="#portfolio">Portfolio</a></li>
                    <li ><a href="#pricing">Pricing</a></li>
                    <li ><a href="#contact">Contact Us</a></li>
                </ul>
            </div>
            <div className="header__menuMobile" onClick={OpenDrawer}>
                <ListIcon />
            </div>
        </div>
    )
}



export default Header;
